import { z } from "zod";
import { IntegrationBaseSchema, IntegrationKey } from "./base";
import {
  FirstMessageMode,
  BackgroundSound,
  TranscriberSettingsSchema,
  VoiceOverrideSettingsSchema,
} from "./voice-agent-configs.contract";

export { FirstMessageMode, BackgroundSound };

export const VoiceAgentIntegrationSettingsSchema = z.object({
  assistantId: z.string().min(1),
  phoneNumberId: z.string().min(1),

  // --- Advanced Settings ---

  firstMessageMode: z
    .enum([
      FirstMessageMode.AssistantSpeaksFirst,
      FirstMessageMode.AssistantWaitsForUser,
      FirstMessageMode.ModelGenerated,
    ])
    .optional(),

  maxDurationSeconds: z.number().int().positive().optional(),

  silenceTimeoutSeconds: z.number().int().positive().optional(),

  endCallMessage: z.string().optional(),

  endCallPhrases: z.array(z.string()).optional(),

  voicemailMessage: z.string().optional(),

  backgroundSound: z
    .enum([BackgroundSound.Off, BackgroundSound.Office])
    .optional(),

  backgroundDenoisingEnabled: z.boolean().optional(),

  hipaaEnabled: z.boolean().optional(),

  recordingEnabled: z.boolean().optional(),

  transcriber: TranscriberSettingsSchema.optional(),

  voiceOverride: VoiceOverrideSettingsSchema.optional(),
});

export type VoiceAgentIntegrationSettings = z.infer<
  typeof VoiceAgentIntegrationSettingsSchema
>;

export const VoiceAgentIntegrationSettingsSchemaWithoutBase = z.object({
  key: z.literal(IntegrationKey.VoiceAgent),
  settings: VoiceAgentIntegrationSettingsSchema,
});

export const VoiceAgentIntegrationSchema = IntegrationBaseSchema.merge(
  VoiceAgentIntegrationSettingsSchemaWithoutBase,
);

export type VoiceAgentIntegration = z.infer<typeof VoiceAgentIntegrationSchema>;
